import history from '../../util/history'

const toEditView = id => {
  history.push(`/daily/id/${id}/edit`)

  return true
}

export default toEditView
